import * as React from "react";
function SvgIcOff(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="currentColor"><rect x={3} y={2} width={1} height={10} rx={0.5} /><rect x={10} y={2} width={1} height={10} rx={0.5} /></g></svg>;
}
export default SvgIcOff;